var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{staticClass:"pt-8",attrs:{"hide-title-row":"","disable-sticky-buttons":"","disable-body-bottom-padding":"","has-buttons":false,"inputs":_vm.mappedSettings},on:{"change":_vm.editSingleSettingHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }